import { useState, useEffect } from 'react';

import { getLocalStorageValue } from './getLocalStorageValue';

interface LocalStorageProps<V = null | unknown> {
  key: string;
  defaultValue: V;
}

export function useLocalStorage<V = null | unknown>({ key, defaultValue }: LocalStorageProps<V>) {
  const [value, setValue] = useState<V>(() => getLocalStorageValue(key, defaultValue));

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue] as const;
}

export type UseLocalStorage = ReturnType<typeof useLocalStorage>;
